import { createContext as t } from "react";
t();
//# sourceMappingURL=index.es50.js.map
